/**
 * Application Header
 * Top navigation bar shown in standalone mode (BaseLayout).
 * Contains the app logo, title, and responsive hamburger menu.
 * Hidden in embedded/iframe mode (EmbedLayout is used instead).
 */

import MenuIcon from "@mui/icons-material/Menu";
import { AppBar, Box, IconButton, Toolbar, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { NonMuiColors } from "@constants/theme.constants";

const StyledAppBar = styled(AppBar)({
  backgroundColor: NonMuiColors.HEADER_GREY,
  boxShadow: "none",
  height: 56
});

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  minHeight: "56px !important",
  paddingInline: "1rem"
});

const LogoSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.75rem"
});

const Header: React.FC = () => {
  const { t } = useTranslation("base");

  return (
    <StyledAppBar position="sticky">
      <StyledToolbar>
        <LogoSection>
          <IconButton
            edge="start"
            color="inherit"
            aria-label={t("eInvoicingApp.nav.menu")}
            sx={{ display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h4Medium"
            color="inherit"
            sx={{ cursor: "pointer" }}
          >
            {t("eInvoicingApp.appTitle")}
          </Typography>
        </LogoSection>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="smallBody" color="inherit" />
        </Box>
      </StyledToolbar>
    </StyledAppBar>
  );
};

export default Header;
